import { render } from "./couponCenter.vue?vue&type=template&id=29126df8&scoped=true"
import script from "./couponCenter.vue?vue&type=script&lang=js"
export * from "./couponCenter.vue?vue&type=script&lang=js"

import "./couponCenter.vue?vue&type=style&index=0&id=29126df8&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29126df8"]])

export default __exports__